import React from "react";

export const setupUrl = (orgId) => `/admin/buyer-setup/${orgId}`;

export function Field({ label, children }) {
  return <label className="block"><span className="label-mono">{label}</span>{children}</label>;
}

export function StepShell({ title, hint, children, footer, testId }) {
  return (
    <section className="brut-card bg-white animate-in fade-in duration-200" data-testid={testId}>
      <div className="px-4 md:px-6 py-4 border-b-2 border-black">
        <h2 className="font-chivo font-black uppercase tracking-tighter text-base md:text-lg">{title}</h2>
        {hint && <p className="text-xs text-zinc-600 mt-1 leading-relaxed max-w-2xl">{hint}</p>}
      </div>
      <div className="p-4 md:p-6 space-y-6">{children}</div>
      {footer && (
        <div className="px-4 md:px-6 py-3 border-t-2 border-black flex flex-wrap items-center justify-end gap-2">{footer}</div>
      )}
    </section>
  );
}
